import React from 'react'
import ErrorModal from '../../../ErrorModal'
import { FormlessJourneyProps } from '../FormlessJourney'
import withDetectRefresh from '../../../HOC/withDetectRefresh'
import FormlessJourneyV4InterstitialWrapper from './FormlessJourneyV4InterstitialWrapper'

const FormlessJourneyV4Wrapper = ({
  experimentName,
  attribution,
  isPreapproved,
  lenderDetails,
  // injected props from HOC
  apiError,
  redirectUrl,
  closeError
}: FormlessJourneyProps): JSX.Element => {
  return (
    <>
      {apiError && (
        <ErrorModal
          titleText="Sorry"
          ctaText="Please try again"
          onClick={closeError}
        >
          There was a problem submitting your application
        </ErrorModal>
      )}

      {!apiError && attribution && (
        <FormlessJourneyV4InterstitialWrapper
          source={attribution.source}
          experimentName={experimentName}
          isPreapproved={isPreapproved}
          lenderDetails={lenderDetails}
          redirectUrl={redirectUrl}
        />
      )}
    </>
  )
}

export default withDetectRefresh(FormlessJourneyV4Wrapper)
